export default __webpack_public_path__ + "static/media/woocommerce.fbb839fb.png";